import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import styles from './ErrorPageEdu.module.less';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../config';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default function SearchResult(props) {
  const { match } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `ErrorPage`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    // 搜索结果页面PV打桩
    dispatch(
      logging({
        category: 'P',
        action: 'ErrorPage',
        label: '',
        param2: {
          source: 'ErrorPage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: match && match.params && match.params.keyword,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'ErrorPage',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  const handleBtn = useCallback(() => {
    history.push(`${CONTEXT}/education/recommend`);
  });

  return (
    <>
      <div className={styles.errorPage}>
        <div className="errorPage_cont">
          <div className="noresult_img" />
          <div className="noresult_text">该课程已下架</div>
          <div className="noresult_btn" onClick={handleBtn}>
            随便逛逛
          </div>
        </div>
      </div>
    </>
  );
}
